// Cross-component wishlist store.
// Single source of truth for items the user has saved. Persists to localStorage
// (`elite_wishlist`) and broadcasts changes across all subscribers so multiple
// cards on the same page stay in sync without prop-drilling.
const KEY = 'elite_wishlist';
const EVENT = 'elite-wishlist-changed';

const read = () => {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return new Set(); }
};

let cache = read();

export const isWishlisted = (id) => cache.has(String(id));

export const toggleWishlist = (id) => {
  const s = String(id);
  if (cache.has(s)) cache.delete(s); else cache.add(s);
  localStorage.setItem(KEY, JSON.stringify([...cache]));
  window.dispatchEvent(new CustomEvent(EVENT));
};

export const subscribeWishlist = (handler) => {
  const onChange = () => handler();
  // Cross-tab updates via the `storage` event; same-tab via our custom event.
  const onStorage = (e) => {
    if (e.key === KEY) { cache = read(); handler(); }
  };
  window.addEventListener(EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
};

// React helper — re-renders the consumer whenever the wishlist changes.
import { useEffect, useReducer } from 'react';
export const useWishlist = () => {
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => subscribeWishlist(force), []);
  return { has: isWishlisted, toggle: toggleWishlist };
};
